import request from "@/utils/request";

export default function agentEditSyncConfigGroup(data) {
  return request({
    url: `/device/device_group/agent/edit_t4/${data.id}`,
    data: { t4: data.t4 },
    method: "post",
  });
}
